export const SET_IS_LOADED = 'CATEGORIES:SET_IS_LOADED';
export const SET_CATEGORIES_LIST = 'CATEGORIES:SET_CATEGORIES_LIST';
